export default {
    namespaced: true,
    state: {
      breadcrumbs: [], // Initialize breadcrumbs as an empty array
    },
    mutations: {
      SET_BREADCRUMBS(state, breadcrumbs) {
       // console.log("Mutation: SET_BREADCRUMBS", breadcrumbs);
        state.breadcrumbs = breadcrumbs;
      },
    },
    actions: {
      updateBreadcrumbs({ commit }, breadcrumbs) {
        // console.log("Action: updateBreadcrumbs triggered", breadcrumbs);
        commit("SET_BREADCRUMBS", breadcrumbs);
      },
    },
    getters: {
      breadcrumbs: (state) => state.breadcrumbs,
    },
  };